module.exports = __webpack_public_path__ + "img/yesbanklogo.3e7f8bba.svg";